// @ts-expect-error module not typed
import PrimaryMessage from '../../primary-message/components/PrimaryMessage';
// @ts-expect-error module not typed
import PrimaryMessageContent from '../../primary-message/components/PrimaryMessageContent';
// @ts-expect-error module not typed
import ContentText from '../../primary-message/ContentText';
import { AGENT } from 'conversations-message-history/constants/messageUses';
import FlexRow from '../../shared/components/FlexRow';
import AutomatedMessageAvatar from '../../avatar/AutomatedMessageAvatar';
import AutomatedMessageHeader from '../../shared/components/AutomatedMessageHeader';
import AutomatedMessageContent from '../../shared/components/AutomatedMessageContent';
import styled from 'styled-components';
import AutomatedMessageFooter from '../../shared/components/AutomatedMessageFooter';
import { AutomatedMessageSource } from '../../shared/components/AutomatedMessageSource';
import { getFullUrl } from 'hubspot-url-utils';
import PortalIdParser from 'PortalIdParser';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledDiv = styled.div.withConfig({
  displayName: "BatchSmsGeneratedUserMessage__StyledDiv",
  componentId: "sc-1uskojd-0"
})(["display:flex;flex-direction:column;width:100%;"]);
const StyledContentColumn = styled.div.withConfig({
  displayName: "BatchSmsGeneratedUserMessage__StyledContentColumn",
  componentId: "sc-1uskojd-1"
})(["display:flex;flex-direction:row;"]);
const BatchSmsGeneratedUserMessage = ({
  message,
  campaignName = '',
  positionDescriptors,
  visitorLastReadTimestamp
}) => {
  const {
    text,
    status,
    timestamp,
    contentId
  } = message;
  const campaignUrl = `${getFullUrl('app')}/sms/${PortalIdParser.get()}/details/${contentId}/`;
  return /*#__PURE__*/_jsxs(PrimaryMessage, {
    "data-test-id": `primary-message-BATCH_SMS`,
    use: AGENT,
    children: [/*#__PURE__*/_jsx(FlexRow, {
      children: /*#__PURE__*/_jsx(PrimaryMessageContent, {
        children: /*#__PURE__*/_jsxs(StyledContentColumn, {
          children: [/*#__PURE__*/_jsx(AutomatedMessageAvatar, {}), /*#__PURE__*/_jsxs(StyledDiv, {
            children: [/*#__PURE__*/_jsx(AutomatedMessageHeader, {
              message: message
            }), /*#__PURE__*/_jsx(AutomatedMessageContent, {
              children: /*#__PURE__*/_jsx(ContentText, {
                contentText: text,
                isPlainText: true
              })
            }), /*#__PURE__*/_jsx(AutomatedMessageSource, {
              sourceLabel: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "conversations-inbox-message-history.batch-sms-generated-user-message.source-campaign"
              }),
              sourceUrl: campaignUrl,
              sourceName: campaignName
            })]
          })]
        })
      })
    }), /*#__PURE__*/_jsx(AutomatedMessageFooter, {
      status: status,
      timestamp: timestamp,
      positionDescriptors: positionDescriptors,
      visitorLastReadTimestamp: visitorLastReadTimestamp
    })]
  });
};
BatchSmsGeneratedUserMessage.displayName = 'BatchSmsGeneratedUserMessage';
export default BatchSmsGeneratedUserMessage;